import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';
import 'firebase/compat/auth';
import 'firebase/compat/messaging';

// ------------------------------------------------------------------
// Firebase Configuration
// ------------------------------------------------------------------
const firebaseConfig = {
  apiKey: "AIzaSyARkaedDOaR3SKLGzb2cc0jwGxd0EqChrg", 
  authDomain: "kyattobaht.firebaseapp.com",
  projectId: "kyattobaht",
  storageBucket: "kyattobaht.appspot.com",
  messagingSenderId: "932729206536",
  appId: "1:932729206536:web:be1fb8371a1d74ecb95ebd",
  measurementId: "G-200ZLPYZDZ"
};

// Initialize App using const to ensure type inference works correctly or is explicitly 'any'.
// We use 'any' here to allow interoperability between Compat and Modular SDKs in the app.
const app: any = !firebase.apps.length 
  ? firebase.initializeApp(firebaseConfig) 
  : firebase.app();

// Initialize Services
const db = app.firestore();
const auth = app.auth();

let messaging: any = null;
if (typeof window !== 'undefined' && 'serviceWorker' in navigator) {
  try {
    messaging = app.messaging();
  } catch (e) {
    console.error("Firebase Messaging Init Error:", e);
  }
}

// Since config is hardcoded, it is always active
const isFirebaseActive = true;

export { db, auth, messaging, isFirebaseActive };
export default app;